(function () {
    'use strict';

    angular
        .module('app')
        .controller('FrontpageController', FrontpageController);

    FrontpageController.$inject = ['$http', '$timeout', '$rootScope', '$scope', '$cookies', '$stateParams', 'localization', 'eventTracker'];

    function FrontpageController($http, $timeout, $rootScope, $scope, $cookies, $stateParams, localization, eventTracker) {
        $rootScope.header_inverted = true;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = false;
        var vm = this;
        vm.showing = 1;
        vm.max_placement = null;
        var timer;
        vm.show_list = false;
        vm.subscribed = false;
        vm.show_type = 'a_concert';
        vm.locationChanged = locationChanged;
        vm.language = localization.getLanguage();


        vm.$onInit = function () {
            window.document.title = $stateParams.language == 'da' ? "Live musik - nærværende musikoplevelser" : "Live music - Music together";

            localization.getLocation().then(function(response) {
                vm.location = response;
                getConcerts();
            });
            getValues();
            slider();
            // temporaryHeader();
            // showBanner()
        };

        $scope.$on('$destroy', function () {
            $timeout.cancel(timer);
        });

        function locationChanged() {
            location.reload();
        }

        function getValues() { //Get data about the elements on the frontpage slider
            $http.get('api/featured/frontpage/')
                .then(function (response) {
                    vm.featured = response.data.featured;
                    vm.max_placement = response.data.count;

                    vm.showing = Math.floor(Object.keys(vm.featured).length*Math.random()) + 1;
                    vm.bannerBackground = vm.featured[vm.showing];
                })
        }

        function next() { //Gets the next object in the slider
            if (vm.showing < vm.max_placement) {
                vm.showing++;
            }
            else {
                vm.showing = 1;
            }
        }

        function slider() { //Slider on the top of frontpage
            timer = $timeout(function () {
                next();
                timer = $timeout(slider, 3000);
            }, 3000000);
        }

        function getConcerts() { //Get a list of concerts
            return $http.post('api/list/concerts/', {offset: 0, limit: 6, sortby: "concert_date", country: localization.getLocationIso()})
                .then(function (response) {
                    vm.concerts = response.data.data;
                    if(vm.concerts.length > 0) {
                        eventTracker.impressionView(vm.concerts, "Frontpage Concert List");
                        eventTracker.detailView(vm.concerts, "Frontpage Concert List");
                    }
                })
        }

        function temporaryHeader(){
            $http.get('api/site_setting/2/is_active/'+localization.getLocationIso())
            .then(function (response) {
                vm.temporary_header = response.data.is_active;
            })
        }

        function showBanner(){
            $http.get('api/site_setting/1/is_active/')
            .then(function (response) {
                vm.show_banner = response.data.is_active;
            })
        }

    }
})();
